import {RefObject, useEffect} from 'react';

/**
 * Hook triggering a function if clicked outside the HTMLElement(s) passed as ref(s)
 */
const useOutsideDetector = (
    refs: RefObject<HTMLElement>[],
    functionToCall: () => void,
) => {
    useEffect(() => {
        /**
         * Trigger if clicked on outside of one of the elements passed as refs
         */
        const handleClick = (event: Event) => {
            const target = event.composedPath()[0];

            let numberOfRefsBeingClickedOutsideOf = 0;
            refs.forEach((ref) => {
                if (
                    ref.current &&
                    !ref.current.contains(target as HTMLElement)
                ) {
                    numberOfRefsBeingClickedOutsideOf += 1;
                }

                if (refs.length === numberOfRefsBeingClickedOutsideOf) {
                    functionToCall();
                }
            });
        };

        // Bind the event listener
        document.addEventListener('mousedown', handleClick, {
            capture: true,
        });

        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClick);
        };
    }, [functionToCall, refs]);
};

export default useOutsideDetector;
